export const FIELD = {
  "Field.Color": {
    ref: "Form.Field.Color"
  }
};
